"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionManagerDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.SessionManagerDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-session-manager');
//# sourceMappingURL=index.js.map